import { IconComponent } from './types';

const DeveloperToolsIcon: IconComponent = (props) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99992 0L13.0621 12L6.99992 7.5L0.937744 12L6.99992 0Z"
      fill="#3D6CB4"
    />
  </svg>
);

export default DeveloperToolsIcon;
